import AddToWalletIcon from './AddToWalletIcon.svg';

export const AddToApple = () => {
  return <img alt='add to wallet icon' src={AddToWalletIcon} />;
};
